<template>
  <zm-drawer @ok="handleSubmit" :title="title" :width="drawerWidth" :visible="visible" size="large" @cancel="cancel">
    <div slot="drawerBody">
      <a-form :form="form">
        <div class="title">产品信息</div>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item label="产品线" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                placeholder="请选择生产线"
                showSearch
                optionFilterProp="children"
                :allowClear="true"
                :disabled="disabled"
                v-decorator="['productLine', { rules: [{ required: true, message: '请选择生产线！' }] }]"
              >
                <a-select-option v-for="(option, index) in productLineList" :key="index" :value="option.code">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item label="产品类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                :allowClear="true"
                placeholder="请选择产品类型"
                @change="handleChange"
                showSearch
                optionFilterProp="children"
                :disabled="disabled"
                v-decorator="['productType', { rules: [{ required: true, message: '请选择产品类型！' }] }]"
              >
                <a-select-option
                  v-for="(option, index) in productTypeList"
                  :key="index"
                  :value="option.code"
                >
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item label="迭代产品" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-switch
                v-decorator="['iterateProductState', { valuePropName: 'checked' }]"
                checked-children="是"
                un-checked-children="否"
                :disabled="disabled"
                @change="iterateProductStateChange"
              ></a-switch>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item label="关联产品" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                :allowClear="true"
                placeholder="请选择关联产品"
                @change="handleChange"
                :disabled="disabled || !form.getFieldValue('iterateProductState')"
                v-decorator="['relateProductId', { rules: [{ required: form.getFieldValue('iterateProductState'), message: '请选择关联产品！' }] }]"
              >
                <a-select-option v-for="option in associatedSelect" :key="option.id" :value="option.id">
                  {{ option.productName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item label="产品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                placeholder="请输入产品名称"
                id="productName"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['productName', { rules: [{ required: true, message: '请输入产品名称！' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item
              label="产品概述"
              :labelCol="labelCol2"
              :wrapperCol="wrapperCol2"
            >
              <zm-editor 
                :height="76"
                v-model="productOverview"
               ></zm-editor>
            </a-form-item>
          </a-col>
        </a-row>
        <div class="title">功能模块</div>
          <mini-modal
            ref="miniModal"
            :form="form"
            :arr="model.productModules"
            :type="type"
          ></mini-modal>
      </a-form>
    </div>
  </zm-drawer>
</template>
<script>
import { mapState } from 'vuex'
import { insertProduct } from '@/api/product'
import miniModal from './miniModal.vue'

export default {
  mounted() {
    console.log('已经加载')
  },
  props: {
    associatedSelect: { type: Array },
  },
  computed: {
    isEdit() {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth() {
      const width = window.innerWidth - 600
      return width
    },
    ...mapState({
      productLineList: (state) => state.product.productLineList,
      productTypeList: (state) => state.product.productTypeList,
    }),
    disabled() {
      return this.type === this.$sysInfo.MODAL_MODIFY
    },
  },
  components: {
    miniModal
  },
  data() {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'product' }),
      visible: false,
      defaultModel: {},
      productOverview: '',
      model: {
        id: '',
        productType: '',
        productModules: [{}],
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      colSpan: 12,
      show: false,
      editorStatus: '',
      editorHelp: '',
    }
  },
  methods: {
    // 设置类型
    setType(type) {
      this.type = type
    },
    // 设置标题
    setTitle(title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel(model) {
      this.model = Object.assign({}, model)
      this.productOverview = model.productOverview
      console.log('productOverview:', this.model.productOverview)
    },
    // 打开or关闭，修改的窗口先获取详情
    open(flag) {
      this.show = flag
      this.visible = flag
      if (this.type === this.$sysInfo.MODAL_MODIFY || this.type === this.$sysInfo.MODAL_VIEW) {
        if (flag) {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              productLine: this.model.productLine,
              productType: this.model.productType,
              iterateProductState: this.model.iterateProductState,
              relateProductId: this.model.relateProductId,
              productName: this.model.productName,
            })
          })
          this.productOverview = this.model.productOverview
        }
      } else {
        this.formClear()
      }
      // 初始化loop组件(动画结束后调用，不然丑)
      setTimeout(() => {
        this.$refs.miniModal.init()
      }, 200);
    },
    // 提交表单
    handleSubmit() {

      // this.model = this.form.productTypeName
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          
          const productModules = this.$refs.miniModal.getData()
         

          console.log('排查：',this.productTypeList,'排查',value.productType);
          console.log('排查：',this.productTypeList.filter(item => item.code === value.productType)[0].name);
          let params = {
            id:this.model.id,
            productLine: value.productLine,
            productLineName: this.productLineList.filter(item => item.code === value.productLine)[0].name,
            productType: value.productType,
            productTypeName: this.productTypeList.filter(item => item.code === value.productType)[0].name,
            iterateProductState: value.iterateProductState,
            productName: value.productName,
            productOverview: this.productOverview,
            productModules
          }
          if(params.productOverview === ''){
            delete params.productOverview
          }
          if(params.iterateProductState){
            params.relateProductId = value.relateProductId
          }

          console.log('处理过的',params);



          if (this.type === this.$sysInfo.MODAL_ADD) {
            delete params.id
            const res = await insertProduct(params).catch((error) => {
              console.log('更新失败', error)
              this.$message.error('更新失败，请稍后重试！')
            })
            if (res && res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.warning(res.info.message)
            }
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            const res = await insertProduct(params).catch((error) => {
              console.log('更新失败', error)
              this.$message.error('更新失败，请稍后重试！')
            })
            if (res && res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.warning(res.info.message)
            }
          }
        }
      })
    },
    // 获取当前的model详情

    handleChange() {},
    // 清空表单
    formClear() {
      this.$nextTick(() => {
        this.model = {}
        this.form.resetFields()
        this.form.setFieldsValue({
          iterateProductState:false
        })
      })
      this.productOverview = ''
    },
    cancel() {
      this.formClear()
      this.open(false)
    },
    // 获取select列表
    getSelectProductModulesList() {
      getSelectProductModulesList().then((res) => {
        if (res.status === 0) {
          this.productModulesList = res.data.list
        }
      })
    },
    iterateProductStateChange(val){
      if(!val){
        this.form.setFieldsValue({
          relateProductId: undefined
        })
      }
    }
  },
}
</script>

<style scoped>
.title {
  font-weight: bold;
  margin-bottom: 10px;
}
.title::before {
  display: inline-block;
  width: 4px;
  height: 12px;
  background: #1791ff;
  content: '';
  margin-right: 7px;
}
.title_1 {
  color: #b3b3b3;
  margin-right: 12px;
}

</style>
